export default "__VITE_ASSET__26d70fba__"